import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { getCurrentUser } from 'helpers/Utils';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    EXPERTS_FETCH_ITEM,
    EXPERTS_ADD_ITEM,
    EXPERTS_SAVE_ITEM,
    EXPERTS_DELETE_ITEM
} from './actions_def';
import {
    getExpertItemSuccess,
    getExpertItemError,
    addExpertsItemSuccess,
    addExpertsItemError,
    saveExpertItemSuccess,
    saveExpertItemError,
    deleteExpertItemSuccess,
    deleteExpertItemError



} from './actions';


const apiUrl = servicePath;


const getExpertItemRequest = async () => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/experts/', { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => (
                    {
                        id: item.rfc_id,
                        title: item.rfc_title,
                        date: moment(item.date_created).format("Do MMM YYYY"),
                        change_date: moment(item.date_modified).format("Do MMM YYYY (hh:mm)"),
                        end_date: moment(item.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                        status: item.rfc_status,
                        statusColor: 'primary'
                    }
                )
                )
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getExpertItem() {
    try {
        const response = yield call(getExpertItemRequest);
        yield put(getExpertItemSuccess(response));
    } catch (error) {
        yield put(getExpertItemError(error));
    }
}


const addExpertsItemRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        var _user = getCurrentUser(); // JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (item.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        let _sendingPayload = {
            title: item.title,
            type: item.type ? item.type : 1,
            summary: item.detail ? item.detail : ' ',
            implementation_start_date: item.start_date ? item.start_date : new Date(),
            status: _status,
            lead: _user.uid
        };

        // console.log(_sendingPayload, getAccessToken());
        instance.post('/experts/',
            _sendingPayload,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status)
                    }
                }
            }).catch((error) => {
                console.log(error)
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* addExpertsItem({ payload }) {

    try {
        const response = yield call(addExpertsItemRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(addExpertsItemSuccess(response));
        }
        else {
            yield put(addExpertsItemError(response));
        }
    } catch (error) {
        yield put(addExpertsItemError(error));
    }
}


const saveExpertRequest = async (item) => {
    // console.log(item);
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        // console.log(item)
        let _sendingPayload = {
            displayName: item.name,
            email: item.email,
            avatar: item.photoURL,
            cover: item.cover
        };

        // console.log(_sendingPayload);
        instance.put('/experts/',
            _sendingPayload,
            { crossdomain: true })
            .then(response => {
                // console.log(response);
                if (response.data) {
                    if (response.status === "fail") {
                        fail(response.data);
                    }
                    else {
                        success(response.data);
                    }

                }
            }).catch((error) => {
                // console.log(error)
                fail(error);
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* saveExpertItem({ payload }) {
    try {
        // // // console.log(payload);;

        const response = yield call(saveExpertRequest, payload.user);
        // console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(saveExpertItemSuccess(response));
        }
        else {
            yield put(saveExpertItemError(response));
        }
    } catch (error) {
        yield put(saveExpertItemError(error));
    }
}



const deleteExpertRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        console.log(item)
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.delete('/experts/' + item + '/',
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success" || response.data.status === "ok") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteExpertItem({ payload }) {
    // console.log(payload);
    try {
        const response = yield call(deleteExpertRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(deleteExpertItemSuccess(response));
        }
        else {
            yield put(deleteExpertItemError(response));
        }
    } catch (error) {
        yield put(addExpertsItemError(error));
    }
}


export function* watchFetchItem() {
    yield takeEvery(EXPERTS_FETCH_ITEM, getExpertItem);
}

export function* watchAddItem() {
    yield takeEvery(EXPERTS_ADD_ITEM, addExpertsItem);
}


export function* watchSaveItem() {
    yield takeEvery(EXPERTS_SAVE_ITEM, saveExpertItem);
}
export function* watchDeleteItem() {
    yield takeEvery(EXPERTS_DELETE_ITEM, deleteExpertItem);
}


export default function* rootSaga() {
    yield all([
        fork(watchAddItem),
        fork(watchFetchItem),
        fork(watchDeleteItem),
    ]);
}
